(function () {
  if (window.__omnisendBisTriggerBound) return;
  window.__omnisendBisTriggerBound = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.js-omnisend-bis-trigger');
    if (!trigger) return;

    let formId = trigger.closest('[data-omnisend-form-id]')?.dataset?.omnisendFormId?.trim();
    if (!formId) {
      const productInfo = document.querySelector('product-info[data-omnisend-form-id]');
      formId = productInfo?.dataset?.omnisendFormId?.trim();
    }
    if (!formId) return;

    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', formId]);
  });
})();
